<template>
  <div class="ws-textbox vhd-container">
    <div class="block block-form-detail">
      <!-- SFS_LANG_ROW_1: Check your details so <airline> can contact you. -->
      <p
        class="text-center"
        v-html="
          replaceStr(
            lang['virtual_helpdesk_new'].SFS_LANG_ROW_37 || 'Check your details so <airline> can contact you.',
            ['<airline>'],
            [airline.name]
          )
        "
      ></p>
      <br />
      <div class="form-content">
        <form class="form-horizontal form-content-detail" @submit.prevent="searchFlight">
          <div
            v-if="airline && airline.params && !!parseInt(airline.params.virtual_enable_pnr)"
            :class="'container ' + marginPnr"
          >
            <div class="form-group">
              <div class="w-100">
                <label for="pnr" class="d-inline-block label-pnr">
                  <!-- SFS_LANG_ROW_2: Booking reference -->
                  {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_2 }}
                  <!-- SFS_LANG_ROW_3: booking code, e-ticket number -->
                  <span class="label-note"> ({{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_3 }}) </span>
                </label>
              </div>
              <div class="d-flex align-items-center position-relative">
                <div class="position-relative pax_contact_confirm w-100">
                  <input
                    id="pnr"
                    v-model="passengerInfo.pnr"
                    class="form-control d-block text-uppercase input-name ml-0"
                    type="text"
                    pattern="[A-Za-z0-9]+"
                    :maxlength="maxPnrLength"
                    placeholder=""
                    name="pnr"
                    @keypress="patternSearch"
                  />
                  <div v-if="samePax || notFoundPnr" class="input-warning text-warning">
                    <i class="fas fa-exclamation-triangle"></i>
                  </div>
                  <div v-if="samePax || notFoundPnr" class="popover show bs-popover-bottom">
                    <div class="arrow"></div>
                    <div class="popover-body">
                      <span v-if="samePax">
                        <!-- SFS_LANG_ROW_22: There are multiple people with the same name. Please provide your booking reference. -->
                        {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_22 }}
                      </span>
                      <span v-if="notFoundPnr">
                        <!-- SFS_LANG_ROW_25: This pnr is not spelled according to our records, please type the pnr exactly. -->
                        {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_25 }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <div
              v-if="airline && airline.params && !!parseInt(airline.params.virtual_enable_lastname)"
              class="mb-3 pax_contact_confirm"
            >
              <label for="lastname" class="d-block">
                <!-- SFS_LANG_ROW_6: Last name -->
                {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_6 }}
              </label>
              <!-- Fix bug SFS-2132 LHG I1040 - Characters on Self service page.Ex: Add more \xC0-\xFF AS ->  https://www.ascii-code.com (C0 -> FF)-->
              <input
                id="lastname"
                v-model="passengerInfo.last_name"
                class="form-control d-block input-name ml-0"
                type="text"
                pattern="[A-Za-z0-9 \-\xC0-\xFF]+"
                name="last_name"
              />
            </div>
            <div
              v-if="airline && airline.params && !!parseInt(airline.params.virtual_enable_firstname)"
              class="position-relative pax_contact_confirm"
            >
              <!-- SFS_LANG_ROW_5: First name -->
              <label for="firstname" class="d-block">{{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_5 }}</label>
              <!-- Fix bug SFS-2132 LHG I1040 - Characters on Self service page.Ex: Add more \xC0-\xFF AS ->  https://www.ascii-code.com (C0 -> FF)-->
              <input
                id="firstname"
                v-model="passengerInfo.first_name"
                class="form-control d-block input-name ml-0"
                type="text"
                pattern="[A-Za-z0-9 \-\xC0-\xFF]+"
                name="first_name"
              />
              <div v-if="samePax || notFoundName" class="input-warning text-warning">
                <i class="fas fa-exclamation-triangle"></i>
              </div>
              <div v-if="samePax || notFoundName" class="popover show bs-popover-bottom">
                <div class="arrow"></div>
                <div v-if="samePax" class="popover-body">
                  <!-- SFS_LANG_ROW_22: There are multiple people with the same name. Please provide your booking reference. -->
                  {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_22 }}
                </div>
                <div v-if="notFoundName" class="popover-body">
                  <!-- SFS_LANG_ROW_23: This name is not spelled according to our records, please type the first name last name exactly as per passport. -->
                  {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_23 }}
                </div>
              </div>
            </div>
          </div>
          <div class="input-group text-center d-block">
            <br />
            <button type="submit" class="ws-btn hd-normal-btn-color" name="btnSearch">
              <!-- SFS_LANG_ROW_10: Search -->
              {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_10 }}
            </button>
          </div>
        </form>
      </div>
      <b-alert
        v-model="showAlertError"
        class="position-fixed fixed-top m-0 rounded-0"
        style="z-index: 2000; border-radius: 1rem !important; border: 1px solid #ffa5a5; color: #444"
        variant="danger"
        dismissible
      >
        <div>
          <div v-for="(error, index) in messagesError" :key="index">
            <div>{{ error }}</div>
          </div>
        </div>
      </b-alert>
    </div>

    <!-- SFS_LANG_ROW_26: Please select the flight: -->
    <b-modal
      v-model="openPopupSelectFlightComputed"
      :title="lang['virtual_helpdesk_new'].SFS_LANG_ROW_26"
      :modal-class="'ws-modal selectFlight'"
      centered
    >
      <div>
        <ul class="m-0">
          <li v-for="(flight, key) in listFlight" :key="key" class="form-check p-2 d-flex">
            <input
              :id="`${key}`"
              v-model="selectedFlightIndex"
              class="form-check-input"
              type="radio"
              :value="flight.id"
              :style="{ 'margin-right': direction == 'rtl' ? '-1.25rem' : '' }"
            />
            <label class="form-check-label align-text-top" :for="`${key}`">{{ displayFlight(flight) }}</label>
          </li>
        </ul>
      </div>
      <template #modal-footer>
        <div>
          <button class="ws-btn hd-normal-btn-color" @click="onSelectedFlight()">
            <!-- SFS_LANG_ROW_10: Search -->
            {{ lang['virtual_helpdesk_new'].SFS_LANG_ROW_10 }}
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { replaceStr } from '@/utils/helper'

export default {
  props: {
    notFoundName: {
      type: Boolean,
      default: false
    },
    notFoundPnr: {
      type: Boolean,
      default: false
    },
    openPopupSelectFlight: {
      type: Boolean,
      default: false
    },
    step: {
      type: String,
      default: ''
    },
    type: {
      type: Number,
      default: 1
    },
    listFlight: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      stepUp: 'this_is_me',
      samePax: false,
      patternInput: /[^a-zA-Z0-9]/,
      selectedFlight: '',
      selectedFlightIndex: null,
      passengerInfo: {},
      showAlertError: false,
      messagesError: [],
      TYPE_VITURAL_HELP_DESK: {
        BOOKING_REF: 1,
        PASSENGER_DETAIL: 2
      },
      search_type: '',
      marginPnr: 'mb-5',
      virtual_enable_lastname: 0,
      virtual_enable_firstname: 0,
      virtual_enable_pnr: 0
    }
  },
  computed: {
    openPopupSelectFlightComputed: {
      get() {
        return this.openPopupSelectFlight
      },
      set(value) {
        this.$emit('updateOpenPopupSelectFlight', value)
      }
    },
    maxPnrLength() {
      if (this.airline?.params?.enable_limit_character_pnr == 1) {
        return 6
      }

      return null // unlimited
    }
  },
  watch: {
    showAlertError: function () {
      let self = this
      if (self.showAlertError) {
        setTimeout(function () {
          self.messagesError = []
          self.showAlertError = false
        }, 5000)
      }
    },
    listFlight(flights) {
      if (flights.length == 1) {
        this.$emit('updateStep', this.stepUp)
      }
    }
  },
  created() {
    if (!this.passengerInfo.flight_date) {
      const today = new Date()
      const fullYear = today.getFullYear()
      const month = ('0' + (today.getMonth() + 1)).slice(-2)
      const date = today.getDate().toString().padStart(2, '0')
      this.passengerInfo.flight_date = `${fullYear}-${month}-${date}`
    }
    let { virtual_enable_lastname, virtual_enable_firstname, virtual_enable_pnr } = this.airline.params
    this.virtual_enable_lastname = parseInt(virtual_enable_lastname)
    this.virtual_enable_firstname = parseInt(virtual_enable_firstname)
    this.virtual_enable_pnr = parseInt(virtual_enable_pnr)

    const enable_pnr_firstname = this.virtual_enable_pnr && this.virtual_enable_firstname && !this.virtual_enable_lastname
    const enable_pnr_lastname = this.virtual_enable_pnr && this.virtual_enable_lastname && !this.virtual_enable_firstname
    if (enable_pnr_firstname || enable_pnr_lastname) this.marginPnr = 'mb-3'
  },
  methods: {
    replaceStr,
    searchFlight: function () {
      this.messagesError = []
      this.showAlertError = false
      this.samePax = false

      const { pnr, first_name, last_name } = this.passengerInfo
      if (this.getConditionSearchPax(pnr, first_name, last_name).some((condition) => condition)) {
        this.messagesError.push('Not enough details entered')
        this.showAlertError = true
        return
      }

      this.showAlertError = false

      if (pnr && last_name && first_name) {
        this.search_type = 'PNR_NAME'
      } else if (pnr && first_name) {
        this.search_type = 'PNR_FIRSTNAME'
      } else if (pnr && last_name) {
        this.search_type = 'PNR_LASTNAME'
      } else if (pnr) {
        this.search_type = 'PNR'
      } else if (last_name && first_name) {
        this.search_type = 'NAME'
      }
      this.$emit('setDataSearchPax', this.passengerInfo, this.search_type)
      this.$emit('searchListFlight')
    },
    getConditionSearchPax: function (pnr, first_name, last_name) {
      const enable_pnr_firstname_lastname =
        this.virtual_enable_lastname && this.virtual_enable_firstname && this.virtual_enable_pnr
      const enable_pnr_firstname = this.virtual_enable_pnr && this.virtual_enable_firstname && !this.virtual_enable_lastname
      const enable_pnr_lastname = this.virtual_enable_pnr && this.virtual_enable_lastname && !this.virtual_enable_firstname
      const enable_firstname_lastname = this.virtual_enable_firstname && this.virtual_enable_lastname && !this.virtual_enable_pnr
      const enable_pnr = this.virtual_enable_pnr && !this.virtual_enable_lastname && !this.virtual_enable_firstname
      const enable_firstname = this.virtual_enable_firstname && !this.virtual_enable_pnr && !this.virtual_enable_lastname
      const enable_lastname = this.virtual_enable_lastname && !this.virtual_enable_pnr && !this.virtual_enable_firstname

      return [
        enable_lastname && !last_name,
        enable_firstname && !first_name,
        enable_pnr && !pnr,
        enable_firstname_lastname && !(first_name && last_name),
        enable_pnr_lastname && (!pnr || !last_name),
        enable_pnr_firstname && (!pnr || !first_name),
        enable_pnr_firstname_lastname && !(pnr || (first_name && last_name))
      ]
    },
    onSelectedFlight: function () {
      let self = this
      if (self.selectedFlightIndex == null) {
        return
      }
      let flight = _.find(self.listFlight, ['id', self.selectedFlightIndex])
      self.selectedFlight = flight
      self.$emit('updateFlightInfo', flight)
      self.$emit('updateOpenPopupSelectFlight', false)
      self.$emit('updateStep', self.stepUp)
    },
    patternSearch: function (e) {
      // prevent the user from entering any characters other than letters and numbers
      if (this.patternInput.test(e.key)) {
        e.preventDefault()
      }
    },
    displayFlight(flight) {
      if (!flight) return
      const _date = new Date(flight.flight_date)
      const year = _date.getFullYear()
      const month = (_date.getMonth() + 1).toString().padStart(2, '0')
      const date = _date.getDate().toString().padStart(2, '0')
      const flight_date = `${year}-${month}-${date}`
      return `${flight.flight_number}\xa0\xa0\xa0  ${flight_date}\xa0\xa0\xa0${flight.dep} - ${flight.div}`
    }
  }
}
</script>
<style lang="scss" scoped>
.block-form-detail {
  .label-note {
    font-size: 14px;
  }

  .arrow {
    left: 124px;
  }
}
.label-pnr {
  text-align: left;
}
</style>
